<template>
  <div class="modal-help">
    <ElementModal @close="closeModal">
      <h2 slot="header">{{ help.text }}</h2>
      <div slot="body">
        <div class="embed-container">
          <iframe :src="help.video" width="500" height="281" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe>
        </div>
      </div>
    </ElementModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ElementModal from '@elements/ElementModal'

export default {
  name: 'TheModalHelp',
  components: {
    ElementModal
  },
  watch: {
    modalName () {}
  },
  computed: {
    ...mapGetters({
      name: 'modal/getName',
      help: 'header/getHelp'
    }),
    showModal () {
      return this.name === 'help'
    }
  },
  created () {
    this.reset = false
  },
  methods: {
    ...mapActions({
      updateName: 'modal/updateName'
    }),
    closeModal () {
      this.updateName('')
    }
  }
}
</script>

<style lang="scss">
.modal-help{

  .modal__container{
    @include media("large") {
      width: 90rem;
    }
  }

  .embed-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;

    iframe{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

  }
}
</style>
